export default {
  'order.FailedToGetPaymentLink': 'Failed to get payment link',
  'order.DidntGetPaymentToken': "Didn't get payment token",
  'order.TheSystemIsDesertedPleasePayAgain': 'The system is deserted, please pay again',
  'order.FailedToCreateAlipayPrepaidOrder': 'Failed to create Alipay prepaid order!',
  'order.FailedToGetPaymentInformation': 'Failed to get payment information',
  'order.MallCashierPagepaymentMethod': 'Mall cashier page_payment method',
  'order.MallCashierPageorderButton': 'Mall cashier page_order button',
  'order.return': 'return',
  'order.agreeAndContinue': 'agree and continue',
  'order.AfterWeChatAuthorizationYouCanEnterTheAccessRequestingAuthorization':
    'After WeChat authorization, you can enter the access, requesting authorization...',
  'order.TheSystemIsOutOfOrder': 'The system is out of order',
  'order.TheSystemIsDesertedPleaseTryAgainLater': 'The system is deserted, please try again later',
  'order.PaymentFailed': 'Payment failed!',
  'order.paymentSuccessful': 'payment successful',
  'order.SuccessfullyPaidJumpingIn': 'Successfully paid, jumping in...',
  'order.WeChat': 'WeChat',
  'order.HuabeiInstallment': 'Huabei installment',
  'order.AlipayScanCodePayment': 'Alipay scan code payment',
  'order.ScanCodePayment': 'Scan code payment',
  'order.QueryFailedPleaseTryAgain': 'Query failed, please try again',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    'The payment is successful, please return to WeChat to continue the operation',
  'order.MallCashierPagePaymentConfirmationPopup': 'Mall cashier page_Payment confirmation popup',
  'order.ParameterError': 'Parameter error!',
  'order.NoPaymentResultDetected': 'No payment result detected',
  'order.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults':
    'If you have already paid, please click refresh to query the results',
  'order.payAgain': 'pay again',
  'order.MallCashierPagepaymentConfirmationPopupconfirmationButton':
    'Mall cashier page_payment confirmation popup_confirmation button',
  'order.refresh': 'refresh',
  'order.MallCashierPagePaymentConfirmationPopupCloseButton':
    'Mall cashier page_Payment confirmation popup_Close button',
  'order.Minute': 'Minute',
  'order.Expect': 'Expect',
  'order.0HandlingFee': '0 handling fee',
  'order.IncludingHandlingFee': 'Including handling fee ￥',
  'order.perIssue': '/per issue',
  'order.recommend': 'recommend',
  'order.PleaseConfirmThatYouHaveReadAndAgree': 'Please confirm that you have read and agree',
  'order.UserServicesAgreement': '"User Services Agreement"',
  'order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent':
    'After paying, you need to come back to confirm the payment result to ensure the smooth distribution of the purchased content!',
  'order.PaymentAmount': 'Payment amount',
  'order.readAndAgree': 'read and agree',
  'order.AreYouSureYouWantToForgoPayment': 'Are you sure you want to forgo payment?'
};
